import { MetricTarget } from '../../../enum';
export var METRICS = [{
  key: 'workVolume',
  name: 'Forecasted Demand',
  idx: 0,
  decimal: 0
}, {
  key: 'productionFte',
  name: 'Production FTE',
  idx: 1,
  decimal: 1
}, {
  key: 'requiredFte',
  name: 'Required (Paid) FTE',
  idx: 2,
  decimal: 1
}, {
  key: 'seatsRequired',
  name: 'Seats Required',
  idx: 8,
  decimal: 0
}, {
  key: 'serviceLevel',
  name: 'Service Level',
  idx: 4,
  percentage: true,
  decimal: 1
}, {
  key: 'asa',
  name: 'ASA',
  idx: 5,
  decimal: 0
}, {
  key: 'occupancy',
  name: 'Occupancy',
  idx: 6,
  percentage: true,
  decimal: 1
}, {
  key: 'abandonment',
  name: 'Abandonment Rate',
  idx: 7,
  percentage: true,
  decimal: 1
}];
export var EXPANDABLE_METRIC_KEYS = ['workVolume', 'productionFte', 'requiredFte', 'seatsRequired', 'serviceLevel', 'asa', 'occupancy', 'abandonment', 'productiveHours', 'productionHours'];
export var QUEUE_ONLY_METRIC_KEYS = ['serviceLevel', 'asa', 'occupancy', 'abandonment'];
export var NO_MULTISKILL_SECTION_METRIC_KEYS = ['serviceLevel', 'asa', 'abandonment'];
export var DAILY_METRIC_TARGET_MAP = {
  serviceLevel: MetricTarget.ServiceLevel,
  asa: MetricTarget.ASA,
  occupancy: MetricTarget.Occupancy
};